import * as dateModifier from "shared/src/date-modifier.mjs";
import * as api from "./services/api";
import * as d from "shared/src/date.mjs";

const NOW_KEY = "acceptance_tests.now";

globalThis.setNow = async function (at, date) {
  const atString = d.toString(d.parseDateTime(at));
  const dateString = d.toString(d.parseDateTime(date));

  localStorage.setItem(NOW_KEY, JSON.stringify({ atString, dateString }));
  dateModifier.setNow(atString, dateString);
  await api.setNow(atString, dateString);
};

globalThis.resetNow = async function () {
  localStorage.removeItem(NOW_KEY);
  await api.resetNow();
  dateModifier.resetNow();
};

globalThis.getNow = function () {
  return dateModifier.getNow();
};

function init() {
  const now = JSON.parse(localStorage.getItem(NOW_KEY));
  if (now == null) {
    return;
  }

  dateModifier.setNow(now.atString, now.dateString);
}

init();
